import { Controller } from "@hotwired/stimulus"

const COOKIE = "sidebar_collapsed"
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

export default class extends Controller<HTMLElement> {
  toggle(): void {
    const collapsed = this.element.dataset.collapsed !== "true"
    this.element.dataset.collapsed = String(collapsed)
    document.cookie = `${COOKIE}=${collapsed}; path=/; max-age=${ONE_YEAR_SECONDS}; SameSite=Lax`
  }
}
